import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

//Solo Facebook y WhatsApp: son los canales que realmente usan los vecinos de
//los municipios. Se quitó Twitter/X, que quedaba desactualizado y sin uso.
import { FacebookShareButton, WhatsappShareButton } from "react-share";

import MPage from "../templates/mpage";
import Cargando from "../components/cargando";
import ErrorMensaje from "../components/errormensaje";

import useObtenerMunicipio from "../../utils/useObtenerMunicipio";
import useObtenerPropuesta from "../../utils/useObtenerPropuesta";
import useTituloPagina from "../../utils/useTituloPagina";

//Hay propuestas cargadas con "-" (o variantes como "--", "—") en los campos
//que no aplican: se tratan igual que un campo vacío y no se muestran.
const tieneValor = (valor) => {
  if (valor === undefined || valor === null) return false;
  const texto = String(valor).trim();
  return texto !== "" && !/^[-–—\s.]+$/.test(texto);
};

const Propuesta = (props) => {
  const [municipio, errorMunicipio] = useObtenerMunicipio(
    props.match.params.munUrl,
  );
  const [propuesta, errorPropuesta] = useObtenerPropuesta(
    props.match.params.propuestaId,
  );
  useTituloPagina(propuesta ? propuesta.titulo : null);

  if (errorMunicipio === true || errorPropuesta === true)
    return (
      <ErrorMensaje
        titulo="No pudimos cargar esta propuesta"
        mensaje="Puede que el enlace sea incorrecto o que haya un problema momentáneo de conexión."
      />
    );
  if (municipio === undefined || propuesta === undefined) return <Cargando />;
  //La propuesta no existe, o todavía no es pública (pendiente de revisión o
  //borrada): se muestra un aviso con vuelta a la página del municipio en vez
  //de redirigir en silencio al inicio.
  if (
    propuesta === null ||
    propuesta.estado === "borrada" ||
    propuesta.estado === "pendiente"
  ) {
    return (
      <ErrorMensaje
        titulo="Esta propuesta no está disponible"
        mensaje="Es posible que haya sido dada de baja o que todavía esté en revisión."
        linkTo={municipio ? `/municipio/${municipio.nombreUrl}` : "/"}
        linkTexto={municipio ? "Volver al municipio" : "Volver al inicio"}
      />
    );
  }

  const decisiones = {
    aceptada: "¡Propuesta aprobada para votación!",
    seleccionada: "¡Propuesta seleccionada para ejecución!",
    archivada: "Propuesta archivada.",
  };

  const decision = decisiones[propuesta.estado];

  //Se arma con el origen actual (window.location.origin) para que los enlaces
  //compartidos funcionen en producción, staging o cualquier otro dominio, sin
  //hardcodear la URL.
  const shareUrl = `${window.location.origin}/municipio/${municipio.nombreUrl}/propuesta/${propuesta._id}`;
  const title = "¡Ayudame a hacer este proyecto realidad!";

  //Votación pública abierta: habilita el CTA de votar. Se excluye Laboulaye
  //2026, que vota en MuniDigital y no por la plataforma.
  const puedeVotar =
    municipio.etapa === "votacion" &&
    municipio.tipoVotacion === "publica" &&
    municipio.nombreUrl !== "laboulaye2020";

  // Datos secundarios que se agrupan dentro de la "ficha del proyecto".
  const ficha = [
    { titulo: "Eje", contenido: propuesta.eje },
    { titulo: "Objetivos", contenido: propuesta.objetivos },
    { titulo: "Beneficiarios", contenido: propuesta.beneficiarios },
    { titulo: "Lugar de acción", contenido: propuesta.laccion },
    { titulo: "Resultados esperados", contenido: propuesta.resultados },
    { titulo: "Periodo de ejecución", contenido: propuesta.pejecucion },
    { titulo: "Descripción general", contenido: propuesta.descripcion },
  ].filter((fila) => tieneValor(fila.contenido));

  return (
    <MPage municipio={municipio}>
      {/* Cabecera destacada: lo más importante */}
      <div className="centrado">
        <div className="propuesta-hero">
          <img
            src={`/api/public/${propuesta.img}`}
            className="propuesta-img"
            alt={propuesta.titulo}
          />
          {decision && (
            <span
              className={`propuesta-estado${
                propuesta.estado === "archivada" ? " es-archivada" : ""
              }`}
            >
              {decision}
            </span>
          )}
        </div>

        <h1 className="propuesta-titulo">{propuesta.titulo}</h1>
        {tieneValor(propuesta.subtitulo) && (
          <p className="propuesta-subtitulo">{propuesta.subtitulo}</p>
        )}

        {municipio.etapa === "seleccion" &&
          propuesta.estado === "seleccionada" &&
          tieneValor(propuesta.ejecucion) && (
            <h5 className="ppr-color-azul font-weight-bold mt-2">
              Estado de Ejecución: {propuesta.ejecucion}
            </h5>
          )}
      </div>

      {/* Bloque destacado: presupuesto + autoría */}
      <div className="propuesta-destacado">
        <div className="propuesta-presupuesto-grande">
          <span className="etiqueta">Presupuesto estimado</span>
          <span className="monto">
            ${propuesta.presupuesto.toLocaleString("es-AR")}
          </span>
        </div>
        <div className="propuesta-autoria">
          {tieneValor(propuesta.autor) && (
            <div className="dato">
              <span className="etiqueta">Autor</span>
              <span className="valor">{propuesta.autor}</span>
            </div>
          )}
          {tieneValor(propuesta.equipo) && (
            <div className="dato">
              <span className="etiqueta">Equipo</span>
              <span className="valor">{propuesta.equipo}</span>
            </div>
          )}
        </div>
      </div>

      {/* Compartir en redes */}
      <div className="propuesta-compartir">
        <span className="compartir-label">Compartir:</span>
        <FacebookShareButton url={shareUrl} quote={title}>
          <FontAwesomeIcon
            icon={faFacebook}
            color="#0a4797"
            title="Compartir en Facebook."
            size="2x"
          />
        </FacebookShareButton>
        <WhatsappShareButton url={shareUrl} title={title}>
          <FontAwesomeIcon
            icon={faWhatsapp}
            color="#0a4797"
            title="Compartir por Whatsapp."
            size="2x"
          />
        </WhatsappShareButton>
      </div>

      {/* CTA de votar en escritorio: inline. En móvil se usa la barra fija de
          abajo (d-none d-md-block / d-md-none los alternan según el ancho). */}
      {puedeVotar && (
        <div className="centrado d-none d-md-block">
          <Link
            to={`/municipio/${municipio.nombreUrl}/votacion/${propuesta._id}`}
            className="btn btn-lg ppr-btn-verde font-weight-bold m-2"
          >
            Votar esta propuesta
          </Link>
        </div>
      )}

      {/* Mensaje del municipio */}
      {municipio.msjProp && (
        <div className="card propuesta-nota" key="mensaje">
          <div className="card-header">MENSAJE IMPORTANTE</div>
          <div className="card-body" style={{ whiteSpace: "pre-line" }}>
            {municipio.msjProp}
          </div>
        </div>
      )}

      {/* Ficha del proyecto: datos secundarios agrupados */}
      {ficha.length > 0 && (
        <div className="card propuesta-ficha">
          <div className="card-header">FICHA DEL PROYECTO</div>
          {ficha.map((fila) => (
            <div className="propuesta-ficha-fila" key={fila.titulo}>
              <span className="etiqueta">{fila.titulo}</span>
              <div className="valor" style={{ whiteSpace: "pre-line" }}>
                {fila.contenido}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Documentación anexa */}
      {tieneValor(propuesta.doc) && (
        <div className="centrado my-3">
          <a
            className="btn ppr-btn-azul font-weight-bold"
            href={`/api/public/${propuesta.doc}`}
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            Descargar documentación anexa
          </a>
        </div>
      )}

      {/* Observaciones: agrupadas bajo un único encabezado, cada una con su
          fecha, en vez de una tarjeta suelta por observación. */}
      {propuesta.observaciones.length > 0 && (
        <div className="card propuesta-nota">
          <div className="card-header">
            {propuesta.observaciones.length === 1
              ? "OBSERVACIÓN DEL MUNICIPIO"
              : "OBSERVACIONES DEL MUNICIPIO"}
          </div>
          <div className="card-body">
            {propuesta.observaciones.map((obs, index) => (
              <div
                key={index}
                className={index > 0 ? "mt-3 pt-3 border-top" : ""}
              >
                <small className="text-muted d-block mb-1">{obs.fecha}</small>
                <div style={{ whiteSpace: "pre-line" }}>{obs.mensaje}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="centrado">
        <Link
          to={`/municipio/${municipio.nombreUrl}`}
          className="btn ppr-btn-verde font-weight-bold m-2"
        >
          Volver
        </Link>
      </div>

      {/* CTA de votar como barra fija inferior (patrón e-commerce): queda
          siempre a la vista mientras el vecino lee la propuesta. El espaciador
          evita que la barra tape el botón "Volver" al final. */}
      {puedeVotar && (
        <div
          className="d-md-none"
          style={{ height: "84px" }}
          aria-hidden="true"
        />
      )}
      {puedeVotar && (
        <div className="cta-votar-sticky d-md-none">
          <Link
            to={`/municipio/${municipio.nombreUrl}/votacion/${propuesta._id}`}
            className="btn ppr-btn-verde font-weight-bold"
          >
            Votar esta propuesta
          </Link>
        </div>
      )}
    </MPage>
  );
};

export default withRouter(Propuesta);
